import { render, staticRenderFns } from "./icons-math.vue?vue&type=template&id=a37246ea&"
import script from "./icons-math.vue?vue&type=script&lang=js&"
export * from "./icons-math.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a37246ea')) {
      api.createRecord('a37246ea', component.options)
    } else {
      api.reload('a37246ea', component.options)
    }
    module.hot.accept("./icons-math.vue?vue&type=template&id=a37246ea&", function () {
      api.rerender('a37246ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/icons-math.vue"
export default component.exports